import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initializeMetaPixel } from "./utils/metaPixel";
initializeMetaPixel();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-193" data-mp="269amiitw3e8h" />);
}